export enum WesterosPwmStrategyItemModalMode {
  CREATE = "create",
  VIEW = "view",
  EDIT = "edit",
}
